import { createContext, useContext } from "react";

export type CustomTranslations = Array<{
  ns: string;
  key: string;
  value: string;
}>;

export const CustomTranslationContext = createContext<{
  translations: CustomTranslations;
  changeTranslation: (ns: string, key: string, value: string) => void;
  deleteTranslations: (ns: string, key: string[]) => void;
}>({
  translations: [],
  changeTranslation: () => undefined,
  deleteTranslations: () => undefined,
});

export const useCustomTranslationContext = () => {
  const context = useContext(CustomTranslationContext);

  if (!context)
    throw new Error(
      "You cannot use CustomTranslationContext outside of it's provider",
    );
  return context;
};
